import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { useSessionValues } from '@/composables/useSessionValues'

import apis from '@/services'

const getPremiumProductsData = async params => {
  const response = await apis.premium.getPremiumPriceDetails(params)
  return response?.data
}

export function usePremiumProductsData({
  rateConnectStatuses,
  plusStatuses,
  proStatuses,
  accommodationIds,
  pageNumber,
  pageSize,
}) {
  const { token } = useSessionValues()
  const { isLoading, isFetching, isSuccess, isError, data } = useQuery({
    queryKey: [
      'premiumProductsData',
      token,
      rateConnectStatuses,
      plusStatuses,
      proStatuses,
      accommodationIds,
      pageNumber,
      pageSize,
    ],
    queryFn: ({ queryKey }) =>
      getPremiumProductsData({
        rateConnectStatuses: queryKey[2],
        plusStatuses: queryKey[3],
        proStatuses: queryKey[4],
        accommodationIds: queryKey[5],
        pageNumber: queryKey[6] ?? 0,
        pageSize: queryKey[7] ?? 10000,
      }),
  })

  const premiumProductsData = computed(() => data?.value?.items ?? [])
  const premiumProductsAccommodationsAmount = computed(() => Object.keys(premiumProductsData.value).length)

  return {
    isPremiumProductsDataLoading: isLoading,
    isPremiumProductsDataFetching: isFetching,
    isPremiumProductsDataSuccess: isSuccess,
    isPremiumProductsDataError: isError,
    premiumProductsData,
    premiumProductsAccommodationsAmount,
  }
}
